import type { BrandRepository } from './brand.repository';
import type { CategoryRepository } from './category.repository';
import type { DeviceRepository } from './device.repository';
import type { ProductRepository } from './product.repository';
import type { WholesalePriceRepository } from './wholesale-price.repository';
import type { WilayaRepository } from './wilaya.repository';

import { supabaseBrandRepository } from './brand.repository';
import { supabaseCategoryRepository } from './category.repository';
import { supabaseDeviceRepository } from './device.repository';
import { supabaseProductRepository } from './product.repository';
import { supabaseWholesalePriceRepository } from './wholesale-price.repository';
import { staticWilayaRepository } from './static/wilaya.repository.static';

export const productRepository: ProductRepository = supabaseProductRepository;
export const brandRepository: BrandRepository = supabaseBrandRepository;
export const categoryRepository: CategoryRepository = supabaseCategoryRepository;
export const wholesalePriceRepository: WholesalePriceRepository = supabaseWholesalePriceRepository;
export const wilayaRepository: WilayaRepository = staticWilayaRepository;
export const deviceRepository: DeviceRepository = supabaseDeviceRepository;
